<template>
  <div id="comp-share">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header">
              <slot name="header"></slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                <div class="add-item" @click="fbShare">
                  <i class="fab fa-facebook-square" style="color:#2a5297"></i>
                  <span>{{ $t('friends.facebook') }}</span>
                </div>
                <div class="add-item" @click="urlShare">
                  <i class="fas fa-link" style="color:#333"></i>
                  <span>{{ $t('friends.url') }}</span>
                </div>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <div class="btn-alone" @click="$emit('close')">{{ $t('friends.btnOK') }}</div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/utils/common';

export default {
  name: 'comp-share',
  mixins: [
    common,
  ],
  computed: {
    getUserURL() {
      const userSeqId = this.$store.getters.getUserSeqId;
      return process.env.SHARE_URI + userSeqId;
    },
  },
  methods: {
    fbShare() {
      const text = this.getUserURL;
      this.$ga.event('ShareMC6', 'FacebookShare', text);
      this.$emit('fbShare', text);
    },
    urlShare() {
      const text = this.getUserURL;
      this.$ga.event('ShareMC6', 'URLShare', text);
      this.$emit('urlShare', text);
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-modal.scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/CompShare.vue